import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { Pagination } from "antd";
import { IdentityAuditPageModel } from "../pageModels/IdentityAuditPageModel";
import { IdentityAudit } from "../../models/IdentityAudit";
import Loading from "../../components/Loading/Loading";
import { globalStore } from "../../models/globalStore";
import ImagePreview from "../../components/ImagePreview/ImagePreview";
import { DateUtil } from "../../utils/DateUtil";

const pageModel = new IdentityAuditPageModel();

const IdentityAuditPage: React.FC = observer(() => {
    const [activeTab, setActiveTab] = useState<"pending" | "processed">("pending");
    const [imagePreviewVisible, setImagePreviewVisible] = useState(false);
    const [currentImageUrl, setCurrentImageUrl] = useState("");
    const [currentImageTitle, setCurrentImageTitle] = useState("身份证照片预览");

    useEffect(() => {
        globalStore.selectedMenuKey = "identity-audit";
        pageModel.loadCandidates();
        pageModel.loadProcessed();
    }, []);

    const openImagePreview = (url: string, title: string) => {
        if (!url) {
            return;
        }
        setCurrentImageUrl(url);
        setCurrentImageTitle(title);
        setImagePreviewVisible(true);
    };

    const renderPhotoLink = (url: string, label: string) => (
        <div
            style={{
                fontSize: "14px",
                color: url ? "#1890ff" : "#ccc",
                fontWeight: 300,
                cursor: url ? "pointer" : "default"
            }}
            onClick={() => openImagePreview(url, label)}
        >
            {label}
        </div>
    );

    const renderAuditList = (audits: IdentityAudit[]) => {
        return (
            <div style={{ padding: "20px" }}>
                {audits.map(audit => (
                    <div
                        key={audit.id}
                        style={{
                            padding: "20px",
                            border: "1px solid #eee",
                            marginBottom: "15px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            background: "white"
                        }}
                    >
                        <div style={{ flex: 1 }}>
                            <div style={{ 
                                display: "flex", 
                                alignItems: "center", 
                                marginBottom: "10px",
                                gap: "20px"
                            }}>
                                <div style={{ 
                                    fontSize: "16px", 
                                    fontWeight: 400,
                                    color: "#333"
                                }}>
                                    {audit.realName || audit.userName}
                                </div>
                                <div style={{ 
                                    fontSize: "14px", 
                                    color: "#666",
                                    fontWeight: 300
                                }}>
                                    {audit.userType === 1 ? "卖家" : audit.userType === 2 ? "买家" : "未知"}
                                </div>
                                <div style={{ 
                                    fontSize: "14px", 
                                    color: "#666",
                                    fontWeight: 300
                                }}>
                                    用户ID：{audit.userId}
                                </div>
                                {activeTab === "pending" && audit.reason && (
                                    <div style={{ 
                                        fontSize: "12px", 
                                        color: "#fa8c16",
                                        fontWeight: 400,
                                        background: "#fff7e6",
                                        padding: "2px 8px"
                                    }}>
                                        复审请求
                                    </div>
                                )}
                            </div>
                            
                            <div style={{ 
                                display: "flex", 
                                alignItems: "center", 
                                marginBottom: "10px",
                                gap: "20px"
                            }}>
                                <div style={{ 
                                    fontSize: "14px", 
                                    color: "#666",
                                    fontWeight: 300
                                }}>
                                    身份证：{audit.idCardNumber}
                                </div>
                                <div style={{ 
                                    fontSize: "14px", 
                                    color: "#666",
                                    fontWeight: 300
                                }}>
                                    提交时间：{audit.applyTime ? DateUtil.formatDatetime(audit.applyTime) : "-"}
                                </div>
                            </div>
                            
                            {audit.reason && (activeTab === "pending" || audit.status === "rejected" || audit.result === "rejected") && (
                                <div style={{ 
                                    fontSize: "14px", 
                                    color: "#ff4d4f",
                                    fontWeight: 300,
                                    marginBottom: "10px"
                                }}>
                                    {activeTab === "pending" ? "上次拒绝理由" : "拒绝理由"}：{audit.reason}
                                </div>
                            )}
                            
                            <div style={{ display: "flex", gap: "20px" }}>
                                {audit.userType === 2 ? (
                                    renderPhotoLink(audit.photoUrl || "", "查看实名照片")
                                ) : (
                                    <>
                                        {renderPhotoLink(audit.idCardFront || "", "查看正面")}
                                        {renderPhotoLink(audit.idCardBack || "", "查看反面")}
                                        {renderPhotoLink(audit.selfieWithIdCard || "", "查看手持照")}
                                    </>
                                )}
                            </div>
                        </div>
                        
                        {activeTab === "pending" && (
                            <div style={{ display: "flex", gap: "10px" }}>
                                <button
                                    style={{
                                        padding: "8px 16px",
                                        background: "#52c41a",
                                        color: "white",
                                        border: "none",
                                        cursor: "pointer",
                                        fontWeight: 400,
                                        fontSize: "14px"
                                    }}
                                    onClick={() => {
                                        pageModel.setSelectedAudit(audit);
                                        pageModel.setShowConfirmDialog(true);
                                    }}
                                >
                                    通过审核
                                </button>
                                <button
                                    style={{
                                        padding: "8px 16px",
                                        background: "#ff4d4f",
                                        color: "white",
                                        border: "none",
                                        cursor: "pointer",
                                        fontWeight: 400,
                                        fontSize: "14px"
                                    }}
                                    onClick={() => {
                                        pageModel.setSelectedAudit(audit);
                                        pageModel.setShowRefuseDialog(true);
                                    }}
                                >
                                    拒绝通过
                                </button>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        );
    };

    return (
        <div style={{ height: "100vh", display: "flex", flexDirection: "column", fontWeight: 300 }}>
            <div style={{ padding: "30px 20px", paddingBottom: "0px" }}>
                <button
                    style={{
                        padding: "8px 16px",
                        marginRight: "10px",
                        border: "none",
                        background: activeTab === "pending" ? "#1890ff" : "#f5f5f5",
                        color: activeTab === "pending" ? "white" : "#666",
                        cursor: "pointer",
                        fontWeight: 400
                    }}
                    onClick={() => setActiveTab("pending")}
                >
                    待审核
                </button>
                <button
                    style={{
                        padding: "8px 16px",
                        border: "none",
                        background: activeTab === "processed" ? "#1890ff" : "#f5f5f5",
                        color: activeTab === "processed" ? "white" : "#666",
                        cursor: "pointer",
                        fontWeight: 400
                    }}
                    onClick={() => setActiveTab("processed")}
                >
                    已审核
                </button>
            </div>

            <div style={{ flex: 1, overflow: "auto" }}>
                {renderAuditList(activeTab === "pending" ? pageModel.pagedCandidates : pageModel.pagedProcessed)}
                <div style={{ padding: "0 20px 20px", textAlign: "right" }}>
                    <Pagination
                        current={activeTab === "pending" ? pageModel.candidatesPage : pageModel.processedPage}
                        pageSize={pageModel.pageSize}
                        total={activeTab === "pending" ? pageModel.candidates.length : pageModel.processed.length}
                        onChange={(page) => {
                            if (activeTab === "pending") {
                                pageModel.setCandidatesPage(page);
                            } else {
                                pageModel.setProcessedPage(page);
                            }
                        }}
                        showTotal={(total) => `共 ${total} 条`}
                        showSizeChanger={false}
                    />
                </div>
            </div>

            {pageModel.showConfirmDialog && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: "rgba(0,0,0,0.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1100
                }}>
                    <div style={{
                        background: "white",
                        width: "400px",
                        padding: "24px",
                        fontWeight: 300
                    }}>
                        <h3 style={{ margin: "0 0 16px 0", fontWeight: 400 }}>确认审核通过</h3>
                        <p style={{ fontWeight: 300 }}>确认通过该用户的实名认证审核吗？</p>
                        <div style={{ marginTop: "24px", textAlign: "right" }}>
                            <button
                                style={{
                                    marginRight: "10px",
                                    padding: "6px 12px",
                                    background: "#f5f5f5",
                                    border: "none",
                                    cursor: "pointer",
                                    fontWeight: 300
                                }}
                                onClick={() => pageModel.setShowConfirmDialog(false)}
                            >
                                取消
                            </button>
                            <button
                                style={{
                                    padding: "6px 12px",
                                    background: "#52c41a",
                                    color: "white",
                                    border: "none",
                                    cursor: "pointer",
                                    fontWeight: 400
                                }}
                                onClick={() => pageModel.approveAudit()}
                            >
                                确认
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {pageModel.showRefuseDialog && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: "rgba(0,0,0,0.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1100
                }}>
                    <div style={{
                        background: "white",
                        width: "400px",
                        padding: "24px",
                        fontWeight: 300
                    }}>
                        <h3 style={{ margin: "0 0 16px 0", fontWeight: 400 }}>拒绝通过</h3>
                        <div style={{ marginBottom: "16px" }}>
                            <label style={{ 
                                display: "block", 
                                marginBottom: "8px", 
                                fontSize: "14px", 
                                color: "#333",
                                fontWeight: 300
                            }}>
                                拒绝原因
                            </label>
                            <textarea
                                value={pageModel.refuseReason}
                                onChange={(e) => pageModel.setRefuseReason(e.target.value)}
                                style={{
                                    width: "100%",
                                    height: "100px",
                                    padding: "8px",
                                    border: "1px solid #d9d9d9",
                                    borderRadius: "0",
                                    fontSize: "14px",
                                    fontWeight: 300,
                                    resize: "none"
                                }}
                                placeholder="请输入拒绝原因"
                            />
                        </div>
                        <div style={{ textAlign: "right", marginTop: "16px" }}>
                            <button
                                style={{
                                    marginRight: "10px",
                                    padding: "6px 12px",
                                    background: "#f5f5f5",
                                    border: "none",
                                    cursor: "pointer",
                                    fontWeight: 300
                                }}
                                onClick={() => pageModel.setShowRefuseDialog(false)}
                            >
                                取消
                            </button>
                            <button
                                style={{
                                    padding: "6px 12px",
                                    background: "#ff4d4f",
                                    color: "white",
                                    border: "none",
                                    cursor: "pointer",
                                    fontWeight: 400
                                }}
                                onClick={() => pageModel.refuseAudit()}
                                disabled={!pageModel.refuseReason}
                            >
                                确认
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {pageModel.loading && <Loading />}
            
            <ImagePreview
                visible={imagePreviewVisible}
                src={currentImageUrl}
                title={currentImageTitle}
                width={600}
                onClose={() => setImagePreviewVisible(false)}
            />
        </div>
    );
});

export default IdentityAuditPage; 